import React from "react";
import { useTranslation } from "react-i18next";
import { useUpdateDocument, useUpdateFolder } from "@planzone/view-models";

import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { TextInput } from "@common/textInput";
import { Props } from "./types";
import styles from "./styles.scss";

function DocumentUpdate({ folder, type, namespace, document, close }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, updateDocument } = useUpdateDocument(document);
  const [name, setName] = React.useState(document.name);

  return (
    <Modal header={t("documentUpdate.title")} close={close}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          !isRequestPending &&
            updateDocument({
              folder,
              type,
              namespace,
              document: { ...document, name },
            });
        }}
        className={styles.updateDocument}
      >
        <div className={styles.main}>
          <TextInput
            placeholder={t("documentUpdate.placeholder")}
            value={name}
            input={setName}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={close}>
            {t("documentUpdate.cancel")}
          </Button>
          <Button status={isRequestPending ? "pending" : "none"} type="submit">
            {t("documentUpdate.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { DocumentUpdate };
